<template>
  <div>
    <button
      @click="showModal = true"
      for="my-modal"
      :class="{ invisible: currentFile && currentFile.activeStep != 1 }"
      class="btn btn-secondary"
    >
      <svg style="width:24px;height:24px" class="mr-2" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M14,12L10,8V11H2V13H10V16M20,18V6C20,4.89 19.1,4 18,4H6A2,2 0 0,0 4,6V9H6V6H18V18H6V15H4V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18Z"
        />
      </svg>
      Importer
    </button>
    <!-- Put this part before </body> tag -->
    <input type="checkbox" id="my-modal" class="modal-toggle" />
    <div class="modal" :class="{ 'modal-open': showModal }">
      <div class="modal-box">
        <h3 class="text-lg font-bold text-center">
          Importer les propositions
        </h3>

        <div class="flex justify-center text-sm breadcrumbs">
          <ul>
            <li>
              <a @click="clearAll">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M20 18H4V8H20M13 17V14H15V17H17V13H19L14 9L9 13H11V17Z"
                  />
                </svg>
              </a>
            </li>
            <li v-if="selectedModule">
              <a @click="cleariFolders">
                {{ selectedModule.moduleName }}
              </a>
            </li>
            <li v-if="selectedFolder">
              <a @click="cleariFiles">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  class="w-4 h-4 mr-2 stroke-current"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  ></path>
                </svg>
                {{ selectedFolder.name }}
              </a>
            </li>
            <li v-if="selectedFile">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z"
                />
              </svg>

              {{ selectedFile.name }}
            </li>
          </ul>
        </div>

        <div v-if="!selectedModule" class="flex flex-col mt-4">
          <h1 class="text-lg font-bold text-center ">Choissisez le module</h1>

          <div class="grid items-center grid-cols-2 gap-4" v-if="$user">
            <div
              class="shadow-lg cursor-pointer card hover:bg-secondary/25"
              v-for="module of $user.listEnterpriseModules"
              :key="module.moduleName"
            >
              <div
                @click="selectedModule = module"
                class="items-center justify-center text-sm font-medium card-body"
              >
                {{ module.moduleName }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col mt-4"
          v-if="selectedModule && !selectedFolder"
        >
          <h1 class="text-lg font-bold text-center ">Choissisez le dossier</h1>

          <div
            class="grid items-center grid-cols-2 gap-4"
            v-if="ifolders.length"
          >
            <div
              class="shadow-lg cursor-pointer card hover:bg-secondary/25"
              v-for="folder of ifolders"
              :key="folder.name"
            >
              <div
                @click="selectedFolder = folder"
                class="items-center justify-center text-sm font-medium card-body"
              >
                <svg
                  style="width:24px;height:24px"
                  class="mb-2 text-primary"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z"
                  />
                </svg>
                {{ folder.name }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col mt-4"
          v-if="selectedFolder && !selectedPropositions"
        >
          <h1 class="text-lg font-bold text-center ">
            Choissisez l'axe d'analyse
          </h1>

          <div class="grid items-center grid-cols-2 gap-4" v-if="ifiles.length">
            <div
              class="shadow-lg cursor-pointer card hover:bg-secondary/25"
              v-for="file of ifiles"
              :key="file.name"
            >
              <div
                @click="selectedFile = file"
                class="items-center justify-center text-sm font-medium card-body"
              >
                <svg
                  style="width:24px;height:24px"
                  viewBox="0 0 24 24"
                  class="text-primary"
                >
                  <path
                    fill="currentColor"
                    d="M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z"
                  />
                </svg>
                {{ file.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col mt-4" v-if="selectedPropositions">
          <h1 class="text-lg font-bold text-center ">
            Choissisez les propositions a importer
          </h1>

          <div class="form-control">
            <label class="flex justify-start cursor-pointer label gap-x-2">
              <input
                @click="toggleAll"
                :checked="allPropositionSelected"
                type="checkbox"
                class="checkbox checkbox-primary"
              />
              <span class="label-text">Tout selectionner</span>
            </label>
          </div>

          <div class="gap-4 " v-if="propositions.length">
            <div
              class="form-control"
              v-for="proposition of propositions"
              :key="proposition.name"
            >
              <label class="flex justify-start cursor-pointer label gap-x-2">
                <input
                  type="checkbox"
                  :value="proposition"
                  v-model="selectedPropositions"
                  class="checkbox checkbox-secondary"
                />
                <span class="label-text">{{ proposition.name }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="modal-action">
          <button
            v-if="selectedPropositions?.length"
            for="my-modal"
            class="btn btn-secondary btn-sm"
            @click="submitSelected"
          >
            Importer
          </button>

          <button
            for="my-modal"
            class="btn btn-primary btn-sm"
            @click="showModal = false"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authMixins from "@/utils/mixins/auth.mixin.js";

export default {
  name: "ImportModal",
  mixins: [authMixins],
  data() {
    return {
      selectedModule: null,
      selectedFolder: null,
      selectedFile: null,
      selectedPropositions: null,
      propositions: [],
      ifolders: [],
      ifiles: [],
      showModal: false,
      loading: false,
      error: false
    };
  },
  watch: {
    selectedModule(val) {
      if (val) this.doFolderLoading();
    },
    selectedFolder(val) {
      if (val) this.doFilesLoading();
    },
    selectedFile(val) {
      if (val) this.doPropositionLoading();
    }
  },
  methods: {
    clearAll() {
      this.selectedModule = null;
      this.selectedFolder = null;
      this.selectedFile = null;
      this.selectedPropositions = null;
    },
    async doFilesLoading() {
      this.ifiles = [];
      this.loading = true;
      this.error = false;
      try {
        const datas = await this.$axios.get(
          "/FileQueries/GetFilesByFolderID/" + this.selectedFolder.id
        );

        this.ifiles = datas.data.map(x => ({
          ...x,
          name: x.fileName,
          description: x.fileDescription,
          objective: x.fileObjective,
          code: x.fileCode,
          id: x.fileID,
          folderID: x.folderID,
          activeStep: x.activeStep
        }));
      } catch (error) {
        console.log(error);
        this.error = true;
        this.$swal.fire({
          title: "Impossible de telecharger vos fichiers",
          text: "Veuillez réessayer",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    submitSelected() {
      this.$emit("selected", [...this.selectedPropositions]);
      this.clearAll();
      this.showModal = false;
    },

    //Method to start loading datas
    async doPropositionLoading() {
      this.propositions = [];
      this.loading = true;
      this.error = false;

      var url;
      switch (this.selectedModule.moduleAbbre) {
        case "AP":
          url = "/PartiePrenantesQueries/GetPartiePrenentByFileID/";
          break;
        case "AR":
          url = "/RisksQueries/GetRiskActivityByFile/";
          break;
        case "MP":
          url = "/MatricesActivityQueries/GetMatriceActivityByFile/";
          break;
        case "MR":
          url = "/MRResultsQueries/GetResultByFile/";
          break;
        default:
          break;
      }

      try {
        const response = await this.$axios.get(url + this.selectedFile.id);
        this.propositions = response.data;
      } catch (error) {
        console.log(error);
        this.error = true;
        this.$swal.fire({
          title: "L'opération a échoué",
          text: "Veuillez réessayer",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }

      this.propositions = this.propositions.sort((a, b) =>
        this.getItemProperty(a).name.toLowerCase() <
        this.getItemProperty(b).name.toLowerCase()
          ? -1
          : this.getItemProperty(a)
              .name.toLowerCase()
              .toLowerCase() >
            this.getItemProperty(b)
              .name.toLowerCase()
              .toLowerCase()
          ? 1
          : 0
      ); // Order by partiePrenanteAbbre

      console.log(this.propositions);
      this.propositions = this.propositions.map(x => ({
        ...this.getItemProperty(x)
      }));
      this.selectedPropositions = [];
      console.log(this.propositions);
    },

    getItemProperty(item) {
      var response = {
        abbrev: "",
        name: "",
        role: ""
      };
      if (!item) return response;
      switch (this.selectedModule.moduleAbbre) {
        case "AP":
          response.name = item.partiePrenanteNom;
          response.abbrev =
            item.partiePrenanteAbbre ?? item.partiePrenanteNom.substring(0, 3);
          response.role = item.partiePrenanteRole;
          console.log(item);
          break;

        case "AR":
          response.name = item.riskName;
          break;

        case "MP":
          response.name = item.activityName;
          break;

        case "MR":
          response.name = item.name;
          break;

        default:
          break;
      }

      return response;
    },

    toggleAll() {
      if (this.allPropositionSelected) {
        this.selectedPropositions = [];
      } else {
        this.selectedPropositions = [...this.propositions];
      }
    },

    toggleProposition(proposition) {
      if (!this.selectedPropositions) {
        this.selectedPropositions = [];
      }
      if (this.selectedPropositions.includes(proposition)) {
        this.selectedPropositions = this.selectedPropositions.filter(
          x => x == proposition
        );
      } else {
        this.selectedPropositions = [...this.selectedPropositions, proposition];
      }
    },

    cleariFolders() {
      this.selectedFolder = null;
      this.selectedFile = null;
      this.selectedPropositions = null;
    },

    cleariFiles() {
      this.selectedFile = null;
      this.selectedPropositions = null;
    },
    async doFolderLoading() {
      this.ifolders = [];
      this.loading = true;
      this.error = false;
      try {
        const datas = await this.$axios.get(
          "/FolderQueries/GetFoldersByModuleID/" +
            this.selectedModule.applicationModuleID +
            "?enterpriseID=" +
            this.$user.enterpriseID
        );
        console.log(datas);
        this.ifolders = datas.data.map(x => ({
          name: x.namePb,
          description: x.descriptionPb,
          result: x.resultat,
          resume: x.resumePb,
          id: x.folderID
        }));
      } catch (error) {
        console.log(error);
        this.error = true;
        this.$swal.fire({
          title: "Impossible de telecharger vos dossiers",
          text: "Veuillez réessayer",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    allPropositionSelected() {
      return this.selectedPropositions.length == this.propositions.length;
    }
  }
};
</script>

<style></style>
